// @flow

import React, { Component, Fragment } from 'react'
import { message } from 'antd'
import moment from 'moment'
import { containerIds } from 'modules/ui'
import { imagePath } from 'frontend_core/dist/helpers/image'
import SMConst from 'frontend_core/dist/constants/sm-const'

type Props = {
  actions: {
    setUIState: Function,
    setCompany: Function,
  },
  ui: {
    isOpenInputAddCard: boolean,
    paymentError: string,
  },
  createCompanyPayment: Function,
  deleteCompanyPayment: Function,
  onChangeCompany: Function,
  config: any,
  company: {
    paymentMethod: number,
    payments: {
      results: Array<{
        id: string,
        name: string,
        type: string,
        last4: string,
        expYear: string | number,
        expMonth: string | number,
      }>,
    },
  },
}

export default class PaymentMethod extends Component<Props> {
  toggleCardInput = () => {
    const { actions, ui } = this.props
    actions.setUIState(containerIds.BUSINESS_SETTING, {
      isOpenInputAddCard: !ui.isOpenInputAddCard,
    })
  }

  changeCardInput = (fieldName: string, value: any) => {
    const { actions, ui } = this.props
    const cardInput = ui.cardInput || {}
    cardInput[fieldName] = value
    actions.setUIState(containerIds.BUSINESS_SETTING, {
      cardInput,
      paymentError: null,
    })
  }

  submitCreateCompanyPayment = () => {
    const { actions, ui, company, config, createCompanyPayment } = this.props
    const cardInput = ui.cardInput || {}
    Stripe.setPublishableKey(config.STRIPE_PUBLISHABLE_KEY)
    Stripe.setLanguage('ja')
    Stripe.card.createToken(
      {
        number: `${cardInput.cardNumber1}${cardInput.cardNumber2}${cardInput.cardNumber3}${cardInput.cardNumber4}`,
        name: cardInput.holderName,
        cvc: cardInput.cvc,
        exp_month: cardInput.expMonth,
        exp_year: cardInput.expYear,
      },
      (status, response) => {
        if (status !== 200) {
          actions.setUIState(containerIds.BUSINESS_SETTING, {
            paymentError: response.error.message,
          })
        } else {
          createCompanyPayment({
            companyId: company.id,
            token: response.id,
          })
            .then(({ data }) => {
              if (data.createCompanyPayment.userErrors.length) {
                message.warning(i18n.t('page.setting.l_00002'))
              } else {
                const payments = data.createCompanyPayment.company.payments
                actions.setCompany({ payments, cardInput: {} })
              }
            })
            .catch(e => {
              message.warning(i18n.t('error.500.title'))
            })
        }
      },
    )
  }

  submitDeleteCompanyPayment = async (paymentId: string) => {
    const { actions, company, deleteCompanyPayment } = this.props
    const res = await deleteCompanyPayment({ id: paymentId })
    const deletedId = res.data.deleteCompanyPayment.deletedCompanyPaymentId
    const userErrors = res.data.deleteCompanyPayment.userErrors
    if (userErrors.length) {
      message.warning(userErrors[0].message)
      return
    }
    const payments = company.payments.results.filter(p => p.id !== deletedId)
    actions.setCompany({
      ...company,
      payments: { results: payments },
      selectedPaymentId:
        company.selectedPaymentId === Number(deletedId)
          ? payments.length
            ? payments[0].id
            : null
          : company.selectedPaymentId,
    })
  }

  render() {
    const { company, ui, onChangeCompany } = this.props
    const cardInput = ui.cardInput || {}

    return (
      <Fragment>
        <h2 className="business-setting-title">お支払い方法</h2>
        <p className="business__supplement">
          クレジットカード、Paidによる銀行振込（Paid）のいずれかをお選びいただけます。
          <br />
          銀行振込（Paid）をご利用の際は、必須項目を入力の上事前に審査申請をお送りください。
        </p>
        <p className="business-reservation-setting__heading business-reservation-setting__heading-pay">
          <span className="icon-form icon-form__required">必須</span>
          お支払い方法
        </p>
        <div className="business-reservation-setting__pay">
          <p className="dashboard-title2">クレジットカード</p>
          <div className="business-reservation-setting__credit dashboard-container__cards">
            {(company.payments.results || []).map((p, i) => (
              <PaymentCard
                key={`payment_card_${i}`}
                {...p}
                checked={
                  company.paymentMethod === SMConst.PaymentMethod.Card &&
                  `${company.selectedPaymentId}` === `${p.id}`
                    ? 'checked'
                    : null
                }
                onClick={() => {
                  onChangeCompany('paymentMethod', SMConst.PaymentMethod.Card)
                  onChangeCompany('selectedPaymentId', p.id)
                }}
                onDelete={() => this.submitDeleteCompanyPayment(p.id)}
              />
            ))}
            <div className="mb20 mt10">
              <a
                href=""
                className="link-hover-border"
                onClick={e => {
                  e.preventDefault()
                  this.toggleCardInput()
                }}
              >
                <i
                  className={`fa fa-chevron-${
                    ui.isOpenInputAddCard ? 'down' : 'right'
                  } mr5`}
                />
                新しいカードを追加
              </a>
            </div>
            {ui.isOpenInputAddCard && (
              <div className="business-reservation-setting__credit-add">
                {ui.paymentError && (
                  <p className="mb15 is-error business-reservation-setting__pay-line">
                    <i className="fa fa-exclamation-circle" />
                    <span>{ui.paymentError}</span>
                  </p>
                )}
                <h3 className="mb5">
                  カード番号
                  <div className="cards-lineup">
                    <img src={imagePath('common/card_visa.png')} />
                    <img src={imagePath('common/card_master.png')} />
                    <img src={imagePath('common/card_jcb.png')} />
                    <img src={imagePath('common/card_amex.png')} />
                    <img src={imagePath('common/card_diners.png')} />
                    <img src={imagePath('common/card_discover.png')} />
                  </div>
                </h3>
                <div className="mb15">
                  <input
                    id="cardNumber1"
                    type="text"
                    className="form-text form-payment-card business__form w60 mr5"
                    value={cardInput.cardNumber1}
                    onChange={e => {
                      this.changeCardInput('cardNumber1', e.target.value)
                      if (e.target.value.length === 4)
                        document.getElementById('cardNumber2').focus()
                    }}
                  />
                  <input
                    id="cardNumber2"
                    type="text"
                    className="form-text form-payment-card business__form w60 mr5"
                    value={cardInput.cardNumber2}
                    onChange={e => {
                      this.changeCardInput('cardNumber2', e.target.value)
                      if (e.target.value.length === 4)
                        document.getElementById('cardNumber3').focus()
                    }}
                  />
                  <input
                    id="cardNumber3"
                    type="text"
                    className="form-text form-payment-card business__form w60 mr5"
                    value={cardInput.cardNumber3}
                    onChange={e => {
                      this.changeCardInput('cardNumber3', e.target.value)
                      if (e.target.value.length === 4)
                        document.getElementById('cardNumber4').focus()
                    }}
                  />
                  <input
                    id="cardNumber4"
                    type="text"
                    className="form-text form-payment-card business__form w60 mr5"
                    value={cardInput.cardNumber4}
                    onChange={e =>
                      this.changeCardInput('cardNumber4', e.target.value)
                    }
                  />
                </div>
                <h3 className="mb5">
                  名義人
                  <span className="dashboard-title__supplement ml15">
                    クレジットカード表記のまま入力してください。半角英数。
                  </span>
                </h3>
                <div className="mb15">
                  <input
                    type="text"
                    className="form-text business-reservation-setting__form business__form w400"
                    value={cardInput.holderName}
                    onChange={e =>
                      this.changeCardInput('holderName', e.target.value)
                    }
                    placeholder="TARO SPACE"
                  />
                </div>
                <h3 className="mb5">有効期限</h3>
                <div className="mb15">
                  <span className="form-select__inner mr10">
                    <label className="form-select">
                      <select
                        className="business__form"
                        value={cardInput.expMonth}
                        onChange={e =>
                          this.changeCardInput('expMonth', e.target.value)
                        }
                        defaultValue=""
                      >
                        <option value="" />
                        <option value="01">01</option>
                        <option value="02">02</option>
                        <option value="03">03</option>
                        <option value="04">04</option>
                        <option value="05">05</option>
                        <option value="06">06</option>
                        <option value="07">07</option>
                        <option value="08">08</option>
                        <option value="09">09</option>
                        <option value="10">10</option>
                        <option value="11">11</option>
                        <option value="12">12</option>
                      </select>
                    </label>
                  </span>
                  <span className="form-select__inner">
                    <label className="form-select">
                      <select
                        className="business__form"
                        value={cardInput.expYear}
                        onChange={e =>
                          this.changeCardInput('expYear', e.target.value)
                        }
                        defaultValue=""
                      >
                        <option value="" />
                        {new Array(
                          moment()
                            .add(20, 'year')
                            .year() - moment().year(),
                        )
                          .fill(0)
                          .map((_, i) => (
                            <option key={i} value={moment().year() + i}>
                              {moment().year() + i}
                            </option>
                          ))}
                      </select>
                    </label>
                  </span>
                </div>
                <h3 className="mb5">
                  セキュリティコード
                  <span className="dashboard-title__supplement ml15">
                    裏面右端の3桁もしくは表面右端の4桁の数字を入力してください。
                  </span>
                </h3>
                <div className="mb15">
                  <input
                    type="text"
                    className="form-text business__form w60"
                    value={cardInput.cvc}
                    onChange={e => this.changeCardInput('cvc', e.target.value)}
                  />
                </div>
                <div>
                  <input
                    type="button"
                    className="button-green w100 pt10 pb10"
                    value="追加"
                    onClick={this.submitCreateCompanyPayment}
                  />
                </div>
              </div>
            )}
          </div>
          <div className="business-reservation-setting__bank mt20">
            <input
              type="radio"
              value="銀行振込"
              id="form-radio01__02"
              name="paymentMethodRadio"
              readOnly
              checked={company.paymentMethod === SMConst.PaymentMethod.Paid}
            />
            <label
              htmlFor="form-radio01__02"
              className="form-radio dashboard-title2 service-radio"
              onClick={() =>
                onChangeCompany('paymentMethod', SMConst.PaymentMethod.Paid)
              }
            >
              銀行振込（Paid）
            </label>
            <img src={imagePath('common/paid_logo.png')} />
            {!company.paidBuyer && (
              <p className="is-error business-reservation-setting__pay-line-paid">
                <span>
                  Paid（株式会社ラクーンフィナンシャル）への登録と与信審査申請が必要です。審査には2〜3営業日かかります。審査のため、後日登録電話番号へご連絡させていただきますのでご了承ください。
                </span>
              </p>
            )}
          </div>
        </div>
      </Fragment>
    )
  }
}

const PaymentCard = ({
  checked,
  onClick,
  onDelete,
  type,
  name,
  last4,
  expYear,
  expMonth,
}) => (
  <p className="request-payment__cards-registered">
    <input
      type="radio"
      checked={checked}
      readOnly
      id="request-radio__01"
      name="paymentMethodRadio"
    />
    <label
      htmlFor="request-radio__01"
      className="service-radio"
      onClick={onClick}
    >
      <img src={imagePath(`common/card_${type}.png`)} />
      <span className="request-payment__name">
        {`**** **** **** ${last4} 名義人：${name} 有効期限：${expMonth}/${expYear}`}
      </span>
    </label>
    <span
      role="button"
      className="is-error request-payment__delete"
      onClick={() => {
        if (window.confirm('このクレジットカード情報を削除しますか？')) {
          onDelete()
        }
      }}
    >
      削除
    </span>
  </p>
)
